import { DataBean } from "../../DataBean";


export class HealthMedication extends DataBean {

    public async getHealthMedicationCatalog(idPharmaLaboratory: any, idPharmaRecordState: any, idPharmaCumState: any, idMeansAdministration: any, idPharmaPresentation: any, idPharmaLaboratoryVendor: any, activeIngredient: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthMedicationCatalog_Number_Number_Number_Number_Number_Number_String_String_Number_Number", [idPharmaLaboratory, idPharmaRecordState, idPharmaCumState, idMeansAdministration, idPharmaPresentation, idPharmaLaboratoryVendor, activeIngredient, regexStr, page, recordsPerPage]);
    }

}